import { render, staticRenderFns } from "./15.vue?vue&type=template&id=ca7d3a2a&scoped=true&"
import script from "./15.vue?vue&type=script&lang=js&"
export * from "./15.vue?vue&type=script&lang=js&"
import style0 from "./15.vue?vue&type=style&index=0&id=ca7d3a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d3a2a",
  null
  
)

export default component.exports